//defined as function for flow's sake... (https://github.com/facebook/flow/issues/3635)
function isFunction(f) {
  return typeof f === "function";
}
module.exports = isFunction;